export default __webpack_public_path__ + "static/media/template_business-man__0023_4---waikinyong.31dce24d.png";